import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "time",
  "use": "time-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"time\"><path d=\"M12 22.08A10.1 10.1 0 1122.1 12 10.11 10.11 0 0112 22.08zm0-18.7A8.6 8.6 0 1020.6 12 8.61 8.61 0 0012 3.38z\" /><path d=\"M14.81 15.53a.71.71 0 01-.53-.22l-2.81-2.8a.75.75 0 01-.22-.53V6.37a.75.75 0 111.5 0v5.3l2.59 2.58a.75.75 0 01-.53 1.28z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol